import React from 'react'
import { FEATURE_LIST } from './scroll-list'
import { FeaturesLanding } from './features-landing'
import { StickyScrollSection } from '../../../shared'

export const FeatureScroll = (): JSX.Element => (
  <StickyScrollSection list={FEATURE_LIST} topElement={<FeaturesLanding />} />
)
